import React, { useEffect, useState } from "react";

import { AcademicYearDTO, LessonHistoryDataRecord, LookupUserDTOV1, SiteDTO } from "@beable/roster-backend-client-v1";
import { getStyles } from "../styles";
import { useTheme } from "@mui/material/styles";
import { Box, FormControl, Grid } from "@mui/material";
import AcademicYearSelector from "../../Common/AcademicYearSelector";
import { Languages } from "@beable/content-types";
import courseService from "../../../services/CourseService";
import UserLessonProgressTable from "./UserSubSections/UserLessonProgressTable";
import LanguageSelector from "../../Common/Selectors/LanguageSelector";

interface UserLessonProgressDataProps {
  user: LookupUserDTOV1;
  site: SiteDTO;
}

export default function UserLessonProgressData({
  user,
  site,
}: UserLessonProgressDataProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [academicYear, setAcademicYear] = useState<AcademicYearDTO>();
  const [lessonProgressData, setLessonProgressData] = useState<LessonHistoryDataRecord[] | undefined>();
  const [lessonLanguage, setLessonLanguage] = useState<Languages>();
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const fetchLessonProgress = async () => {
      if (user && user.userAccountId && academicYear && lessonLanguage) {
        setIsLoading(true);
        const lessonProgressResp = await courseService.getUserLessonHistoryData(
          site.id,
          user.userAccountId,
          academicYear.academicYearId,
          academicYear.schoolYear,
          lessonLanguage,
          site.timezone || "",
          academicYear.startAt,
          academicYear.endAt,
          0,
          1000
        );
        setLessonProgressData(lessonProgressResp?.results);
        setIsLoading(false);
      }
    };
   
    fetchLessonProgress();
  }, [user, site, academicYear, lessonLanguage]);

  function AdditionalDropdowns() {
    return (
      <Grid container sx={styles.progress_sectionContainer} spacing={4}>
        <Grid size={5}>
          <AcademicYearSelector
            siteId={site.id}
            handleSelection={(academicYear: AcademicYearDTO | undefined) => {
                setAcademicYear(academicYear);
              } 
            }
            variant="outlined"
          />
        </Grid>
        <Grid size={5}>
          <FormControl sx={styles.pFormControl} variant='outlined'>
            <LanguageSelector
              onChange={(e: any) => {
                setLessonLanguage(e.target.value);
              }}
              lang={lessonLanguage || undefined}
              labelText="User's Application Language"
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }

  const isLoginTicket = !user.userAccountId;

  if (isLoginTicket)
  return (<span> This information is only available for claimed accounts</span>);
  
  return (
    <Box sx={{ padding: 10 , minHeight: "500px" }}>
      {AdditionalDropdowns()}
      {!isLoading && academicYear && lessonLanguage && (
        <UserLessonProgressTable
          lessonProgress={lessonProgressData}
          profile={user}
          academicYear={academicYear}
          languageCode={lessonLanguage}
        />
      )}
    </Box>
  )
}

